/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class SpecialPrograms extends SubCatAccordion implements IsubCatAccordion
    {
        toolTipHeader: string = "What special academic programs are a must-have at the college you choose?";

        typeCbs = [{
            type: "Accelerated Study", isChecked: false
        },
            { type: "Distance Learning", isChecked: false },
            { type: "Double Majors", isChecked: false },
            { type: "Honors Program", isChecked: false },
            { type: "Independent Study", isChecked: false },
            { type: "Internships", isChecked: false },
            { type: "Self-designed majors", isChecked: false },
            { type: "Study Abroad", isChecked: false }];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
}